import { MouseEvent } from 'react';
import { useBoolean } from '@shared/util/hooks';
import { ButtonProps } from './ButtonProps';

type AsyncOnClickProps = Pick<ButtonProps, 'onClick' | 'loading'>;

type AsyncOnClickReturn = [boolean, ButtonProps['onClick']];

export function useOnClickAsync({
  onClick,
  loading = false,
}: AsyncOnClickProps): AsyncOnClickReturn {
  const [isWaiting, startWaiting, stopWaiting] = useBoolean(false);

  async function onClickAsync(event: MouseEvent<HTMLButtonElement>) {
    // start waiting if onPress returns a promise
    const result = onClick?.(event);
    if (result instanceof Promise) {
      try {
        startWaiting();
        await result;
      } finally {
        stopWaiting();
      }
    }
  }

  return [isWaiting || loading, onClickAsync];
}
